module.exports = __webpack_public_path__ + "static/media/Michelndorf.4d485aba.webp";